import { loadProducts } from 'axp-product-ducks';
import { Map as map } from 'immutable';

/*
* loading language pack - the the pack will be loaded based axp-locale
* loadMember - calls member api to load the card member details in state tree
* loadMerchants - moved call to component level
* */
const loadModuleData = () => (dispatch) => Promise.all([
  dispatch(loadProducts()),
]);

export function loadDataAsProps({ ownProps }) {
  return {
    location: () => ({ location: ownProps.location }),
  };
}

loadDataAsProps.ssr = true;

const initialState = map({ activeTile: 'maps' });
export const reducer = () => initialState;

export default loadModuleData;
